module.exports = __webpack_public_path__ + "static/img/all_channel_pay.57559c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/all_channel_pay.png
// module id = 2w38
// module chunks = 8